const moduleRoutes = [
    {
        path: '/package-gifts',
        name: 'packageGifts',
        children: [
            {
                path: '',
                name: 'packageGiftList',
                component: () => import('@/modules/package_gifts/list/List.vue'),
                meta: {
                    resource: 'packages',
                    action: 'view_gift',
                    layout: 'default',
                    auth: true,
                    title: 'Package Gifts',
                    breadcrumbs: [{ title: 'Package Gift List', routeName: 'packageGiftList' }]
                }
            }
        ]
    }
]

export default moduleRoutes
